/* [polecenie właściciela 2026-09-11, F-8] Lustro reguł sejfu haseł po stronie przeglądarki.

   „oko odkrywa hasło na dokładnie 5 sekund (…) kopiuj wkłada hasło do schowka na 30 sekund, potem
    NADPISUJE go fałszywymi danymi”.

   ── DLACZEGO TE LICZBY SĄ TUTAJ, A NIE WPISANE W KOMPONENT ──────────────────────────────────
   Serwer oddaje je przy każdym ujawnieniu (`oknoSekundy`, `oknoSchowkaSekundy`) i to ONE są
   źródłem prawdy — tutejsze wartości są zapasem na wypadek starszej odpowiedzi. Trzymamy je
   w jednym pliku, bo rozsypane po komponentach rozjechałyby się przy pierwszej zmianie, a rozjazd
   tutaj znaczy hasło widoczne dłużej, niż powiedział właściciel.

   ── NADPISANIE, A NIE CZYSZCZENIE ───────────────────────────────────────────────────────────
   Pusty schowek u części systemów zostawia POPRZEDNIĄ zawartość, a menedżery schowka i tak
   pamiętają historię. Wstawienie innej treści wypycha hasło z historii i z podglądu schowka. */

/* [zgłoszenie właściciela 2026-09-11 wieczór] „odsłonięcie hasła jest przez 15 sekund”
   (rano było 5 s — patrz RegulySejfu.OknoUjawnieniaSekundy, gdzie stoi powód zmiany).
   Wartość MUSI być równa tej po stronie serwera: serwer przysyła ją w `oknoSekundy`, a to tutaj
   jest zapasem na starszą odpowiedź — zapas krótszy albo dłuższy od prawdy to hasło znikające
   nie wtedy, kiedy zapowiedział to odliczany licznik. */
export const OKNO_UJAWNIENIA_S = 15;
export const OKNO_SCHOWKA_S = 30;

/** Treść wypychająca hasło ze schowka po upływie okna. */
export const falszywaZawartoscSchowka = () =>
    `schowek wyczyszczony przez menedzer hasel — ${new Date().toISOString().slice(0, 19).replace("T", " ")}`;

export const ZAKRES = {
    osobisty: "osobisty",
    dzial: "dzial",
    modul: "modul",
};

export const ETYKIETY_AKCJI = {
    podglad: "Wyświetlenie hasła",
    // [polecenie właściciela 2026-10-03] Akcja istniała po stronie serwera (RegulySejfu.AkcjaPodgladHaslem),
    // a raport i dziennik wpisu pokazywały jej surowy kod „podglad-haslem”.
    "podglad-haslem": "Wyświetlenie hasła (potwierdzone hasłem konta)",
    kopiowanie: "Skopiowanie do schowka",
    utworzenie: "Utworzenie wpisu",
    edycja: "Zmiana wpisu",
    usuniecie: "Usunięcie wpisu",
    // [polecenie właściciela 2026-10-03] Ślady importu z pliku Excel (RegulySejfu.AkcjaImport / AkcjaImportZmiana).
    import: "Import z pliku Excel",
    "import-zmiana": "Zmiana hasła importem z pliku Excel",
};

/* [przegląd H2 2026-10-04] RAPORT WGLĄDÓW: które ślady są ZAPISEM (utworzenie, zmiana, usunięcie, import), a nie
   ujawnieniem hasła. Każdy wiersz importu z Excela zostawia ślad „obcy” (wpis działowy jest zawsze „obcy”), więc bez tego
   podziału import 500 haseł pokazałby w kaflu „500 wglądów w cudze”, a prawdziwe ujawnienia zginęłyby w tłumie.
   To jest lista ZAPISÓW, nie ujawnień: akcja nieznana (np. nowa po stronie serwera) liczy się jako WGLĄD — lepiej
   pokazać za dużo niż schować ujawnienie. */
export const AKCJE_ZAPISU_SEJFU = ["utworzenie", "edycja", "usuniecie", "import", "import-zmiana"];

/** Ślad raportu jest wglądem w hasło (wyświetlenie, kopiowanie albo akcja, której ekran nie zna). */
export const jestWgladem = (akcja) => !AKCJE_ZAPISU_SEJFU.includes(akcja);

/* Lustro `RegulySejfu.LimitRaportu` (SejfController.Raport): raport oddaje najwyżej tyle NAJNOWSZYCH wglądów i OSOBNO
   tyle samo zmian i importów. To tylko zapas, gdy odpowiedź nie niesie `limit`; czy okno się przepełniło, mówią pola
   `obcietoWglady` / `obcietoZapisy` odpowiedzi (nie liczba pozycji — ta może sięgać 2 × limit). */
export const LIMIT_RAPORTU_SEJFU = 5000;

/* ── [polecenie właściciela 2026-10-03] IMPORT HASEŁ Z PLIKU EXCEL ──────────────────────────────
   „w sekcji /admin/password-manager dodaj mi możliwość importu pliku z hasłami — pliku excel,
    z przypisaniem bazy haseł do konkretnego działu / modułu / działu w aplikacji, z opcją pobrania
    pliku wzorcowego”.

   Klucz importu jest need-to-know i nadawany wyłącznie imiennie (serwer: PermissionCatalog, explicit-only).
   Limity są tu ZAPASEM — prawdą są `limity` z GET /sejf/import/cele. */
export const KLUCZ_IMPORTU_SEJFU = "SejfImportBankow";

export const LIMITY_IMPORTU_ZAPAS = { maksBajtow: 5 * 1024 * 1024, maksWierszy: 2000 };

/** Co zrobić, gdy wiersz pliku ma tę samą nazwę, login i adres co wpis, który już jest w banku. */
export const POLITYKI_DUPLIKATOW = [
    { id: "pomin", label: "Pomiń", opis: "Zostaw wpis w banku bez zmian." },
    { id: "zastap", label: "Zastąp hasło", opis: "Wpisz hasło z pliku w miejsce obecnego. Tylko członek działu." },
    // [sprawdzenie całości 2026-10-04] Serwer (SejfImportPlan, ostrzeżenie dodaj_bez_prawa) dopisuje drugi taki sam wpis
    // tylko członkowi działu; spoza działu duplikat jest pomijany. Opis mówi to od razu, a nie dopiero w podglądzie.
    { id: "dodaj", label: "Dodaj jako nowy wpis", opis: "W banku będą dwa wpisy o tej samej nazwie. Tylko członek działu — spoza działu duplikat zostanie pominięty." },
];

/** Nazwa pliku wzorcowego, gdy odpowiedź nie niesie nagłówka Content-Disposition. */
export const NAZWA_WZORU_ZAPAS = "wzór-importu-haseł.xlsx";
